import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NotaTicket } from 'src/app/page/ticket/nota';
import { ImagemBase64 } from 'src/app/model/imagemBase64';

@Component({
  selector: 'app-ticket-comentarios',
  templateUrl: './ticket-comentarios.component.html',
  styleUrls: ['./ticket-comentarios.component.scss'],
})
export class TicketComentariosComponent {

  @ViewChild('imageDialog') imageDialog!: TemplateRef<any>;

  @Input() formulario!: FormGroup;
  @Input() comentarios: NotaTicket[] = [];
  @Input() loading = false;
  @Input() lastPage = false;
  @Input() novoComentario = '';
  @Input() imagensSelecionadas: ImagemBase64[] = [];

  @Output() novoComentarioChange = new EventEmitter<string>();
  @Output() adicionarComentario = new EventEmitter<void>();
  @Output() carregarMais = new EventEmitter<void>();
  @Output() arquivoSelecionado = new EventEmitter<Event>();
  @Output() removerImagem = new EventEmitter<number>();

  constructor(public dialog: MatDialog) { }

  onNovoComentarioChange(valor: string) {
    this.novoComentarioChange.emit(valor);
  }

  abrirPreviewImagem(img: { base64: string; nome: string }): void {
    this.dialog.open(this.imageDialog, {
      data: img,
      maxWidth: '90vw'
    });
  }

  isImageFile(fileName?: string): boolean {
    if (!fileName) {
      return false;
    }
    const imageExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg'];
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    return imageExtensions.includes(fileExtension || '');
  }
}
